export const page_background = "#f4f4f4";
export const label_color = "#585858";
export const border_color = "#d5d5d5";

export const theme_primary_500 = "#040001";
export const theme_secondary_500 = "#e54937";
export const theme_secondary_100 = "#fff8f8";

export const white = "#ffffff";
